module.exports = __webpack_public_path__ + "images/next/recruiting_services/square-90f328f5fc5261cab4cbb6453b007409.png";